import Swal from 'sweetalert2'

export class Alert {
    public static buildSuccessAlert(title:string){
        Swal.fire({
            title: title,
            toast: true,
            background: "rgba(0,145,7,0.8)",
            position: "top-end",
            timer: 5000,
            showConfirmButton: false,
            customClass:{
                title: 'colorWhite'
            }
            // type: "success"
        
        })
        // Swal.fire('Hola','Hola','success')
    }
    public static buildErrorAlert(title:string){
        Swal.fire({
            title: title,
            toast: true,
            background: "rgba(147,10,40, 0.8)",
            position: "top-end",
            timer: 5000,
            showConfirmButton: false,
            customClass:{
                title: 'colorWhite'
            }
            // type: "success"
        
        })
    }
}